import type { ChangeEvent, ReactNode } from "react";
import { FilterBar } from "./FilterBar";
import { SearchField } from "./SearchField";
import {
  StatusFilterSelect,
  type StatusFilterValue,
} from "./StatusFilterSelect";

// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): la barra de filtros completa
// (buscador, selector de estado, separador flexible y botón "Nuevo…") era el
// mismo marcado palabra por palabra en BenefitsScreen.tsx y
// RewardsScreen.tsx. `extraFilters` es la ranura para el selector propio de
// cada pantalla (tipo de consumo en Beneficios, categoría en Recompensas),
// que sí difiere entre ambas. Extracción sin cambio de comportamiento ni de
// valores visuales.
export function ScreenToolbar({
  searchValue,
  onSearchChange,
  searchPlaceholder,
  extraFilters,
  statusValue,
  onStatusChange,
  actions,
}: {
  searchValue: string;
  onSearchChange: (event: ChangeEvent<HTMLInputElement>) => void;
  searchPlaceholder: string;
  extraFilters?: ReactNode;
  statusValue: StatusFilterValue;
  onStatusChange: (value: StatusFilterValue) => void;
  actions: ReactNode;
}) {
  return (
    <FilterBar>
      <SearchField
        value={searchValue}
        onChange={onSearchChange}
        placeholder={searchPlaceholder}
      />
      {extraFilters}
      <StatusFilterSelect value={statusValue} onChange={onStatusChange} />
      <div style={{ flex: 1 }} />
      {actions}
    </FilterBar>
  );
}
